const tariffBitPermissions = require('./tariffBitPermissions');
const tariffs = require('./bookTariffs');
const stripeTariffs = require('./stripebookTariffs');

const bitPermissionsSum = (permissionsArray) => {
    return permissionsArray.reduce((permissionsSum, permission) => permissionsSum + permission, 0);
};
/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    /** **************************** NEW STRIPE TARIFFS *************************************/
    // lite
    [stripeTariffs.LITE_2024_MONTH_CZK.name]: {
        tariffName: stripeTariffs.LITE_2024_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_YEAR_CZK.name]: {
        tariffName: stripeTariffs.LITE_2024_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_MONTH_EUR.name]: {
        tariffName: stripeTariffs.LITE_2024_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_YEAR_EUR.name]: {
        tariffName: stripeTariffs.LITE_2024_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_MONTH_USD.name]: {
        tariffName: stripeTariffs.LITE_2024_MONTH_USD.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_YEAR_USD.name]: {
        tariffName: stripeTariffs.LITE_2024_YEAR_USD.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_MONTH_HUF.name]: {
        tariffName: stripeTariffs.LITE_2024_MONTH_HUF.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_YEAR_HUF.name]: {
        tariffName: stripeTariffs.LITE_2024_YEAR_HUF.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_MONTH_PLN.name]: {
        tariffName: stripeTariffs.LITE_2024_MONTH_PLN.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_YEAR_PLN.name]: {
        tariffName: stripeTariffs.LITE_2024_YEAR_PLN.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_MONTH_GBP.name]: {
        tariffName: stripeTariffs.LITE_2024_MONTH_GBP.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.LITE_2024_YEAR_GBP.name]: {
        tariffName: stripeTariffs.LITE_2024_YEAR_GBP.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    // professional
    [stripeTariffs.PROFESSIONAL_2024_MONTH_CZK.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_YEAR_CZK.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_MONTH_EUR.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_YEAR_EUR.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_MONTH_USD.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_MONTH_USD.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_YEAR_USD.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_YEAR_USD.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_MONTH_HUF.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_MONTH_HUF.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_YEAR_HUF.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_YEAR_HUF.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_MONTH_PLN.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_MONTH_PLN.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_YEAR_PLN.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_YEAR_PLN.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_MONTH_GBP.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_MONTH_GBP.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.PROFESSIONAL_2024_YEAR_GBP.name]: {
        tariffName: stripeTariffs.PROFESSIONAL_2024_YEAR_GBP.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    // expert
    [stripeTariffs.EXPERT_2024_MONTH_CZK.name]: {
        tariffName: stripeTariffs.EXPERT_2024_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_YEAR_CZK.name]: {
        tariffName: stripeTariffs.EXPERT_2024_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_MONTH_CZK.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_YEAR_CZK.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_MONTH_EUR.name]: {
        tariffName: stripeTariffs.EXPERT_2024_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_YEAR_EUR.name]: {
        tariffName: stripeTariffs.EXPERT_2024_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_MONTH_EUR.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_YEAR_EUR.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_MONTH_USD.name]: {
        tariffName: stripeTariffs.EXPERT_2024_MONTH_USD.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_YEAR_USD.name]: {
        tariffName: stripeTariffs.EXPERT_2024_YEAR_USD.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_MONTH_USD.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_MONTH_USD.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_YEAR_USD.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_YEAR_USD.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_MONTH_HUF.name]: {
        tariffName: stripeTariffs.EXPERT_2024_MONTH_HUF.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_YEAR_HUF.name]: {
        tariffName: stripeTariffs.EXPERT_2024_YEAR_HUF.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_MONTH_HUF.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_MONTH_HUF.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_YEAR_HUF.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_YEAR_HUF.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_YEAR_PLN.name]: {
        tariffName: stripeTariffs.EXPERT_2024_YEAR_PLN.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_MONTH_PLN.name]: {
        tariffName: stripeTariffs.EXPERT_2024_MONTH_PLN.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_MONTH_PLN.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_MONTH_PLN.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_YEAR_PLN.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_YEAR_PLN.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_MONTH_GBP.name]: {
        tariffName: stripeTariffs.EXPERT_2024_MONTH_GBP.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.EXPERT_2024_YEAR_GBP.name]: {
        tariffName: stripeTariffs.EXPERT_2024_YEAR_GBP.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_MONTH_GBP.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_MONTH_GBP.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.ULTIMATE_2025_YEAR_GBP.name]: {
        tariffName: stripeTariffs.ULTIMATE_2025_YEAR_GBP.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },

    /** **************************** NEW but deprecated STRIPE TARIFFS *************************************/
    // freelancer
    [stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_CZK.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_EUR.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_USD.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_USD.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_HUF.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_HUF.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_PLN.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_PLN.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_GBP.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_MONTH_COMPATIBILITY_GBP.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },

    [stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_CZK.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_EUR.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_USD.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_USD.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_HUF.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_HUF.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_PLN.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_PLN.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_GBP.name]: {
        tariffName: stripeTariffs.FREELANCER_2024_YEAR_COMPATIBILITY_GBP.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },

    // studio
    [stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_CZK.name]: {
        tariffName: stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_EUR.name]: {
        tariffName: stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_USD.name]: {
        tariffName: stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_USD.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_HUF.name]: {
        tariffName: stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_HUF.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_PLN.name]: {
        tariffName: stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_PLN.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_GBP.name]: {
        tariffName: stripeTariffs.STUDIO_2024_MONTH_COMPATIBILITY_GBP.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_CZK.name]: {
        tariffName: stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_EUR.name]: {
        tariffName: stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_USD.name]: {
        tariffName: stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_USD.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_HUF.name]: {
        tariffName: stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_HUF.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_PLN.name]: {
        tariffName: stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_PLN.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_GBP.name]: {
        tariffName: stripeTariffs.STUDIO_2024_YEAR_COMPATIBILITY_GBP.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },

    /** **************************** FREELANCER *************************************/
    // CZK
    [tariffs.FREELANCER_2021_MONTH_CZK.name]: {
        tariffName: tariffs.FREELANCER_2021_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [tariffs.FREELANCER_2021_YEAR_CZK.name]: {
        tariffName: tariffs.FREELANCER_2021_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    // EUR
    [tariffs.FREELANCER_2021_MONTH_EUR.name]: {
        tariffName: tariffs.FREELANCER_2021_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    [tariffs.FREELANCER_2021_YEAR_EUR.name]: {
        tariffName: tariffs.FREELANCER_2021_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
    /** ******************************* STUDIO **************************************/
    // CZK
    [tariffs.STUDIO_2021_MONTH_CZK.name]: {
        tariffName: tariffs.STUDIO_2021_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [tariffs.STUDIO_2021_YEAR_CZK.name]: {
        tariffName: tariffs.STUDIO_2021_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    // EUR
    [tariffs.STUDIO_2021_MONTH_EUR.name]: {
        tariffName: tariffs.STUDIO_2021_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [tariffs.STUDIO_2021_YEAR_EUR.name]: {
        tariffName: tariffs.STUDIO_2021_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    /** ******************************* STUDIO PRO **********************************/
    // CZK
    [tariffs.STUDIO_PRO_2021_MONTH_CZK.name]: {
        tariffName: tariffs.STUDIO_PRO_2021_MONTH_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
            tariffBitPermissions.SOMETHING_ELSE,
        ]),
    },
    [tariffs.STUDIO_PRO_2021_YEAR_CZK.name]: {
        tariffName: tariffs.STUDIO_PRO_2021_YEAR_CZK.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
            tariffBitPermissions.SOMETHING_ELSE,
        ]),
    },
    // EUR
    [tariffs.STUDIO_PRO_2021_MONTH_EUR.name]: {
        tariffName: tariffs.STUDIO_PRO_2021_MONTH_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
            tariffBitPermissions.SOMETHING_ELSE,
        ]),
    },
    [tariffs.STUDIO_PRO_2021_YEAR_EUR.name]: {
        tariffName: tariffs.STUDIO_PRO_2021_YEAR_EUR.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
            tariffBitPermissions.SOMETHING_ELSE,
        ]),
    },
    /** ********************************* TRIAL *************************************/
    [tariffs.TRIAL.name]: {
        tariffName: tariffs.TRIAL.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [tariffs.TRIAL_STUDIO.name]: {
        tariffName: tariffs.TRIAL_STUDIO.name,
        bitPermissions: bitPermissionsSum([
            tariffBitPermissions.BASIC_FUNCTIONALITY,
            tariffBitPermissions.CREATE_LECTURER,
        ]),
    },
    [tariffs.TRIAL_FREELANCER.name]: {
        tariffName: tariffs.TRIAL_FREELANCER.name,
        bitPermissions: bitPermissionsSum([tariffBitPermissions.BASIC_FUNCTIONALITY]),
    },
};
